export const techStackContent = {
  title: 'My Tech Stack',
  glowColor: '#9C27B0',
  message: 'This is the Tech Stack page of my coming soon... Or is it?',
};
